module.exports = __webpack_public_path__ + "static/media/7.5593996e.jpg";